<template>
  <Command v-if="canShare" @click="share">
    <slot
      v-bind="{
        disabled: false,
        icon: 'share',
        label: t('moreOptions.share'),
        toolTip: t('moreOptions.share'),
      }"
    />
  </Command>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { posthogKeys } from "@/helpers/constants";
import { usePostHog } from "@/helpers/posthog";
import { useWpsClient } from "@/wps/client";

import Command from "../command";

const { t } = useI18n();
const { capture: capturePosthogEvent } = usePostHog();

const wpsClient = useWpsClient();

const shareData = computed<{
  title: string;
  text: string;
  url: string;
}>(() => {
  const pub = wpsClient.publication;
  if (!pub) return null;

  return {
    title: pub.metadata.title.getTranslation("en"),
    text: pub.metadata.description || t("reader.sharedText"),
    url: wpsClient.canonicalUrl?.href || window.location?.href,
  };
});

const canShare = computed(() => {
  return (
    wpsClient.token.isSample &&
    window.navigator.share &&
    window.navigator.canShare(shareData.value)
  );
});

async function share() {
  await window.navigator.share(shareData.value);
  capturePosthogEvent(posthogKeys.sampleShare);
}
</script>
